import React, { useRef, useState, useEffect } from 'react';
import { bool, func, string } from 'prop-types';
import Search from 'ps-components/Search/Search';

import SmartInfo from './SmartInfo';
import SmartSearchOptions from './SmartSearchOptions';
import useOutsideAlerter from '../../lib/useOutsideAlerter';
import './SmartSearch.scss';

SmartSearch.propTypes = {
  reportViewUser: bool,
  restrictedUser: bool,
  showSlideout: func,
  subsite: string
};

function SmartSearch(props) {
  const [searchText, setSearchText] = useState('');
  const [showOptions, setShowOptions] = useState(false);

  const searchInputRef = useRef();
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, setShowOptions);

  if (props.reportViewUser || props.restrictedUser) {
    return null;
  }

  function clearInput() {
    searchInputRef.current?.setSearchValue('');
  }

  function searchOnChange(e) {
    setSearchText(e.target.value);
    if (e.target.value) {
      setShowOptions(true);
    }
  }

  // when pressing enter to execute a search
  function searchOnKeyDown(event) {
    if (event.key === 'Enter') {
      console.log('Enter pressed');
    }
  }

  // clicking x to clear search text
  function searchOnClick() {
    setSearchText('');
  }

  function onFocus() {
    setShowOptions(true);
  }

  return (
    <div className="smart-search" ref={wrapperRef} onFocus={onFocus}>
      <div className="smart-search__upper">
        <Search
          className="smart-search__search"
          onChange={searchOnChange}
          onClick={searchOnClick}
          onKeyDown={searchOnKeyDown}
          placeholder="Quick Nav"
          testId="smart-search__search"
          value={searchText}
        />

        <SmartInfo className="smart-search__info-container" />
      </div>

      <SmartSearchOptions
        clearInput={clearInput}
        searchText={searchText}
        showOptions={showOptions}
        subsite={props.subsite}
        showSlideout={props.showSlideout}
      />
    </div>
  );
}

export default SmartSearch;
